import { render, staticRenderFns } from "./LicensePools.vue?vue&type=template&id=c3588632&"
import script from "./LicensePools.vue?vue&type=script&lang=js&"
export * from "./LicensePools.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports